export const SET_DATE = 'SET_DATE';
export const CLEAR_DATE = 'CLEAR_DATE';

// Image Upload
export const SET_IMAGE_DATA = "IMAGES/SET_IMAGE_DATA";
export const SET_UPLOAD_PROGRESS = 'IMAGES/SET_UPLOAD_PROGRESS';
export const SET_UPLOAD_SUCCESS = 'IMAGES/SET_UPLOAD_SUCCESS';
export const SET_UPLOAD_FAILURE = 'IMAGES/SET_UPLOAD_FAILURE';
export const REMOVE_IMAGE = "IMAGES/REMOVE_IMAGE";
export const REMOVE_SEVERAL_UPLOADED_IMAGES = "IMAGES/REMOVE_SEVERAL";
export const REMOVE_ALL = "IMAGES/REMOVE_ALL";


// WEBPACK FOOTER //
// ./src/shared/redux/actionTypes.js